import React from 'react';
import '../styles/CreatorBadge.css';

/**
 * CreatorBadge Component
 *
 * Displays a creator/verified badge on user avatars.
 * Can be positioned absolute to overlay on avatar.
 *
 * Props:
 * - size: 'small' | 'medium' | 'large' (default: 'small')
 * - className: Additional CSS class
 */
const CreatorBadge = ({ size = 'small', className = '' }) => {
  return (
    <div className={`creator-badge-icon creator-badge-icon--${size} ${className}`}>
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

export default CreatorBadge;
